import { type Tile } from "@vega-modules/scenes/CoInvestmentsLP/components/Welcome/WelcomeStepsTiles";
import { resolveVegaIcon } from "@vega-modules/utils/resolveVegaIcon";

import { WelcomeStepView } from "../steps/WelcomeStepView";

import { readWelcomeContent } from "./content";
import { type StepProps } from "./taskRenderers";
import { useCompleteTaskV2 } from "./useCompleteTaskV2";

export const WelcomeStepV2 = ({ task, onComplete }: StepProps) => {
  const { completeTask, isPending } = useCompleteTaskV2();
  const { heading, description, infoTiles } = readWelcomeContent(task.content);

  const tiles: Tile[] | undefined = infoTiles?.map((tile) => ({
    icon: resolveVegaIcon(tile.icon) ?? null,
    title: tile.title,
    description: tile.subtitle,
  }));

  const handleSubmit = () => {
    completeTask(
      {
        taskId: task.id,
        data: { capturedData: {} },
      },
      { onSuccess: () => onComplete() },
    );
  };

  return (
    <WelcomeStepView
      description={description}
      heading={heading}
      isSubmitting={isPending}
      onSubmit={handleSubmit}
      tiles={tiles}
    />
  );
};
